import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * @param {Object} props
 * @param {string} [props.className]
 */
export const MenuDivider = ({ className }) => {
  return (
    <span role="separator" aria-orientation="vertical" className={cn(menuVariants.divider(), className)}>
      <span className="block h-full w-px bg-tertiary-98" />
    </span>
  )
}

MenuDivider.propTypes = {
  className: PropTypes.string,
}
